import api from '@/api'
import $util from '@/utils/utils'
let currentTime;
let startTime = Date.now();
const addLog = (from, to) => {
  // 绑定微信弹框的路由，需确认是否需要记录
  // if(to.name=='bindWechat' &&to?.query?.noReload=='true') {
  //   return
  // }
  let openFrom = sessionStorage.getItem('openFrom')
  // a标签跳转的单独处理
  let aWebLog = localStorage.getItem("a-web-log")
  let user = localStorage.getItem('gt6_user_info')
  user = user ? JSON.parse(user) : {}
  let previousPageUrl = from.fullPath
  if(aWebLog) {
    aWebLog = JSON.parse(aWebLog) 
    previousPageUrl = aWebLog.openFrom
  } else if(from.fullPath === "/" && openFrom) {
    previousPageUrl = openFrom
  } else {
    previousPageUrl = $util.getCurrentWebSiteByProduct() + previousPageUrl
  }
  currentTime = Date.now()
  const log = {
    // 上一个页面的Url
    previousPageUrl,
    authorizationToken: user.customerId,
    identityId: $util.getGuid(),
    hostName: location.origin,
    // 当前页面URl
    pageUrl:  $util.getCurrentWebSiteByProduct() + to.fullPath,
    // 当前页面标题
    pageTitle: document.title || to?.meta?.title || to?.meta?.name || '',
    // 当前页面停留时间
    timeOnPage: Date.now(), 
    operation: 'load',
    active: 1, // 是否活跃，1小时/5小时内出现弹框为不活跃状态0
    // timeOnPage: parseInt((currentTime - startTime) / 1000), 
  };
  // startTime = Date.now()
  sessionStorage.setItem("webLog", JSON.stringify({...log}))
  localStorage.removeItem('a-web-log')
  sessionStorage.removeItem('openFrom')
  // sessionStorage.setItem('openFrom', previousPageUrl)
  api.logs.addWebLogs(log)
}
export default {
  addLog
}